import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { COLORS } from '../config/colors';
import { strings } from '../strings';
import type { RootStackParamList } from '../types/navigation';
import GuidesIcon from './icons/GuidesIcon';

/**
 * Opens the guides screen. It sits in the map's right-hand button column,
 * directly below `NewsButton`.
 */
const GuidesButton = () => {
  const navigation =
    useNavigation<NativeStackNavigationProp<RootStackParamList>>();
  const insets = useSafeAreaInsets();

  const handlePress = () => {
    navigation.navigate('Guides');
  };

  return (
    <Pressable
      accessibilityLabel={strings.openGuides}
      accessibilityRole="button"
      onPress={handlePress}
      style={({ pressed }) => [
        styles.button,
        // Same look as the other floating buttons, placed below the news
        // button: 12 (top inset) + 44 + 12 (news button) + 12 (gap).
        { top: insets.top + 124, right: 12 },
        pressed && styles.buttonPressed,
      ]}
    >
      <GuidesIcon color={COLORS.ink} />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    width: 44,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 15,
    backgroundColor: COLORS.surface,
    shadowColor: '#000000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  buttonPressed: {
    opacity: 0.8,
  },
});

export default GuidesButton;
